// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lLWV","index":"styles_index__16vHZ"};